import React from "react";
import { useState, useEffect, useRef } from "react";
import LoadingBar from "react-top-loading-bar";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import Pdf2ImagePDFListScreen from "./Pdf2ImagePDFListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";

function Pdf2ImageMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Convert PDF to JPG, PNG, SVG, WEBP, BMP Securely",
  };
  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_to_image", title: "PDF to .png" },
    data2: { link: "/pdf_to_image", title: "PDF to image" },
    data3: { link: "/pdf_to_image", title: "Extract pdf pages as image" },
  };

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert PDF to image online easily. Turn PDF pages into JPG or PNG images quickly with our fast, secure, and easy PDF to image converter."
      ></meta>
      <meta
        name="keywords"
        content="pdf to image, pdf to image converter, convert pdf to image, pdf to jpg, pdf to png, pdf pages to images, online pdf to image, pdf to photo, pdf image converter, extract images from pdf, convert pdf pages to jpg, pdf to png converter, pdf to picture, pdf file to image, pdf converter online"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <Pdf2ImagePDFListScreen title={title}></Pdf2ImagePDFListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our PDF to JPG Converter website offers a fast, secure, and efficient way to convert PDF documents into high-quality images without requiring an internet connection. Designed to work fully offline, this powerful image converter allows users to transform PDF pages into JPG, JPEG, PNG, WEBP, or SVG formats while keeping all processing on the device for maximum privacy. Whether you need to extract images, share documents on social platforms, or use PDF content in presentations, this tool makes conversion simple and reliable. Users can convert files using PDF to JPG online or choose offline processing for sensitive documents, enjoying the flexibility of an advanced online converter with offline capabilities. The platform supports multiple output formats, including PDF to PNG online, PDF to JPEG, PDF to WEBP, and PDF to SVG, making it suitable for a wide range of use cases. With options to export each page individually or PDF to single image, users have full control over the final output. Optimized for speed and clarity, the converter preserves image resolution, colors, and sharp text during conversion. Ideal for students, designers, professionals, and businesses, this website provides a seamless way to convert PDFs into images using a secure PDF to JPG converter, PDF to image converter, and online converter solution that works both offline and online." />
          {/* How to use define max 4 steps */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Extract",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF to image converter"
            why_use={[
              {
                title: "Convert PDF to Image Easily",
                description:
                  "Our PDF to image converter allows you to quickly convert PDF files into JPG, PNG, SVG, WEBP, and BMP formats for better usability and accessibility.",
              },
              {
                title: "Best Offline PDF to Image Converter",
                description:
                  "Using an offline PDF to image converter ensures secure PDF conversion, as files are processed locally without uploading to the internet.",
              },
              {
                title: "Universal File Compatibility Across Devices",
                description:
                  "Image formats created using a PDF to JPG converter or PDF to PNG converter can be opened on any device without a PDF reader.",
              },

              {
                title: "High-Quality PDF to Image Conversion",
                description:
                  "Preserve original layout, fonts, and colors with high-resolution PDF to image conversion for professional results.",
              },
              {
                title: "Multiple Image Format Support",
                description:
                  "Choose the right format using a PDF to JPG, PDF to PNG, PDF to SVG, PDF to WEBP, or PDF to BMP converter based on your requirements.",
              },
              {
                title: "No Software Installation Needed",
                description:
                  "A browser-based PDF to image converter online offline works instantly without downloading or installing any software.",
              },
              {
                title: "Perfect for Design, Marketing & Presentations",
                description:
                  "Converted images can be used in graphic design, social media marketing, PowerPoint presentations, and website content.",
              },
              {
                title: "Free & User-Friendly PDF to Image Tool",
                description:
                  "Our free PDF to image converter saves time and boosts productivity for students, professionals, and businesses.",
              },
              {
                title: "Faster Sharing & Downloading",
                description:
                  "Image files created by a PDF to image conversion tool are easier to share via email, messaging apps, and cloud platforms.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1632843204}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default Pdf2ImageMain;
